import type { RouteObject } from "react-router-dom";

import { authManagementRoutes } from "@routes/authManagement/route";
import { studentEmailVerificationRoutes } from "@routes/student/emailVerification/route";

export const outsideRoutes: RouteObject[] = [
  ...(authManagementRoutes?.map((item) => item?.route) || []),
  ...(studentEmailVerificationRoutes?.map((item) => item?.route) || []),
];
